import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';

import { HisSharedModule } from 'hisng';

import { CommonSharedModule } from 'app/fs/res/common/common-shared.module';

import { PatentEditFormComponent } from './component/patent/patent-edit-form.component';
import { PatentEditBasicDataTabComponent } from './component/patent/edit/patent-edit-basic-data-tab.component';
import { PatentEditBasicDataComponent } from './component/patent/edit/basic-data/patent-edit-basic-data.component';
import { PatentEditClassificationTabComponent } from './component/patent/edit/patent-edit-classification-tab.component';

import { PatentViewDetailsComponent } from './component/patent/patent-view-details.component';
import { PatentViewVCardComponent } from './component/patent/view/patent-view-vcard.component';
import { PatentViewInventorsDetailsComponent } from './component/patent/view/details/patent-view-inventors-details.component';
import { PatentEditInventorsComponent } from './component/patent/edit/basic-data/patent-edit-inventors.component';
import { PatentEditFinanceTabComponent } from './component/patent/edit/patent-edit-finance-tab.component';
import { PatentResearchTabComponent } from './component/patent/edit/patent-research-tab.component';

import { PatentSearchFormComponent } from './component/patent/patent-search-form.component';
import { PriorityPatentSearchFormComponent } from './component/patent/prioritypatent-search-form.component';
import { PatentSearchResultComponent } from './component/patent/patent-search-result.component';
import { PatentViewFamilyComponent } from './component/patent/view/basic-data/patent-view-family.components';
import { PatentEditRegistrationOrganizationsComponent }
    from './component/patent/edit/basic-data/patent-edit-registration-organizations.component';
import { PatentViewDynamicFieldsComponent } from './component/patent/view/dynamicfields/patent-view-dynamicfields.component';
import { PriorityPatentViewProjectsComponent } from './component/patent/edit/research/priority-patent-view-projects.component';
import { PatentExternalInventorDialogComponent }
    from './component/patent/edit/basic-data/inventors/patent-external-inventor-dialog.component';
import { PatentEditInventorPercentageComponent }
    from './component/patent/edit/basic-data/inventors/patent-edit-inventor-percentage.component';
import { PatentInternalInventorWizardComponent }
    from './component/patent/edit/basic-data/inventors/patent-internal-inventor-wizard.component';
import { PatentSearchInternalPersonInventorComponent }
    from './component/patent/edit/basic-data/inventors/patent-search-internal-person-inventor.component';

/**
 * SharedModule for patents.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        CommonSharedModule,

        // primeng
        AutoCompleteModule,
        CalendarModule,
        ConfirmDialogModule,
        FileUploadModule,
        InputTextModule,
        PanelModule,
        TableModule,
        TabViewModule,
        DataViewModule,
        DialogModule,
        StepsModule,

        // HIS
        HisSharedModule
    ],

    declarations: [
        // Main Forms
        PatentEditFormComponent,
        PatentSearchFormComponent,
        PriorityPatentSearchFormComponent,
        PatentSearchResultComponent,

        // edit
        PatentEditBasicDataComponent,
        PatentEditInventorsComponent,
        PatentEditRegistrationOrganizationsComponent,
        PatentEditBasicDataTabComponent,
        PatentEditFinanceTabComponent,
        PatentEditClassificationTabComponent,
        PatentResearchTabComponent,
        PriorityPatentViewProjectsComponent,
        PatentExternalInventorDialogComponent,
        PatentEditInventorPercentageComponent,
        PatentInternalInventorWizardComponent,
        PatentSearchInternalPersonInventorComponent,

        // view
        PatentViewDetailsComponent,
        PatentViewVCardComponent,
        PatentViewFamilyComponent,
        PatentViewInventorsDetailsComponent,
        PatentViewDynamicFieldsComponent,
    ],

    exports: [
    ]
})
export class PatentSharedModule {
}
